"use strict";import{Theme as e}from"../Theme.js";import r from"./theme.css.js";e.registerThemeFragment("express","theme",r);
//# sourceMappingURL=core.js.map
